/* DARKGROUND DESIGN SYSTEM · commerce behaviour + site-wide scroll reveal
   - [data-dg-gallery]: product image switcher
   - [data-dg-demo]: hero demo player. Only shows when the product has a track with "demo" in its AW Player title.
   - [data-dg-previews]: one main player on top + the full sound list, fed by the product's AW Player tracks.
     The main player starts on the "demo" track (or the longest one). Clicking any sound in the list loads it into
     the main player (waveform grows in), plays it and marks it in the list. While playing, the waveform lights up
     in real time with a playhead and a few bars pulsing at the play position (cheap: only 3 bars animate).
     Click the waveform to jump. Sound names are shown exactly as in AW Player.
   - [data-dg-upsell-slot]: moves the Essential Upsell offer from the hidden theme form into view
   - scroll reveal: blocks fade in when they enter the screen (whole site, not the first screen)
   Only one sound plays at a time, and each sound stops at its end (no auto-advance).
*/
(function () {
  'use strict';

  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"></path></svg>';
  var EQ = '<span class="dg-eq" aria-hidden="true"><i></i><i></i><i></i></span>';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  var REVEAL = [
    '.dg-section .dg-head', '.dg-section .dg-grid > *', '.dg-marquee', '.dg-tiles', '.dg-ftrack',
    '.dg-ct', '.dg-ct__footer', '.dg-sound > *', '.dg-buy__grid > *', '.dg-acc', '.dg-faq__footer',
    '.dg-stats > li', '.dg-logos > li', '.dg-split__media', '.dg-bx__media', '.dg-bx__body',
    '.dg-statement .dg-display', '.dg-statement .dg-lead', '.dg-reviews__head', '.dg-reviews__apps',
    '.dg-ab', '.dg-offer__actions', '.dg-demo__bottom > *'
  ].join(',');
  var revealIO = null;
  function canReveal() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return false;
    if (!('IntersectionObserver' in window)) return false;
    if (reducedMotion) return false;
    return true;
  }
  function markReveal(el, delay) {
    if (!el || el.dataset.dgReveal) return;
    el.dataset.dgReveal = '1';
    if (delay) el.style.setProperty('--dg-reveal-delay', delay + 'ms');
    el.classList.add('dg-reveal');
    revealIO.observe(el);
  }
  function initReveal(root) {
    if (!canReveal()) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-revealed'); revealIO.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
    var first = sections.filter(function (s) { return s.offsetHeight > 2; })[0];
    root.querySelectorAll(REVEAL).forEach(function (el) {
      if (first && first.contains(el)) return;
      if (el.closest('.dg-hero, .dg-phero, .dg-intro, .dg-sticky')) return;
      var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      markReveal(el, Math.min(Math.max(idx, 0), 5) * 90);
    });
    sections.forEach(function (s) {
      if (s === first || s.offsetHeight < 3) return;
      if (s.querySelector('.dg')) return;
      if (/__main$/.test(s.id)) return;
      markReveal(s.firstElementChild, 0);
    });
  }

  /* ---------- one sound at a time ---------- */
  var shared = { audio: null, owner: null };
  function getAudio(owner) {
    if (!shared.audio) { shared.audio = new Audio(); shared.audio.preload = 'none'; }
    if (shared.owner && shared.owner !== owner && shared.owner.onStop) shared.owner.onStop();
    shared.owner = owner;
    return shared.audio;
  }

  var cache = {};
  function getTracks(pid) {
    if (!cache[pid]) {
      cache[pid] = fetch('/apps/awplayer/tracks?product_id=' + pid)
        .then(function (r) { return r.json(); })
        .then(function (d) { return ((d && d.tracks) || []).filter(function (t) { return t && t.url; }); })
        .catch(function () { return []; });
    }
    return cache[pid];
  }

  function isDemo(t) { return /demo/i.test((t && t.title) || ''); }
  function seconds(d) {
    if (typeof d === 'string' && d.indexOf(':') > -1) { var p = d.split(':'); return (+p[0]) * 60 + (+p[1]); }
    return parseFloat(d) || 0;
  }
  function fmt(s) {
    s = Math.max(0, Math.round(s || 0));
    if (!s) return '';
    var m = Math.floor(s / 60), r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function findDemo(tracks) {
    for (var i = 0; i < tracks.length; i++) { if (isDemo(tracks[i])) return i; }
    return -1;
  }
  function findLongest(tracks) {
    var best = 0;
    tracks.forEach(function (t, i) { if (seconds(t.duration) > seconds(tracks[best].duration)) best = i; });
    return best;
  }
  function smoothBars(str, n) {
    var vals = (str || '').split(',').map(function (x) { return Math.abs(parseFloat(x) || 0); });
    var out = [], i, j;
    if (vals.length < 2) { for (i = 0; i < n; i++) out.push(0.4 + 0.35 * Math.abs(Math.sin(i * 0.45))); return out; }
    var size = vals.length / n;
    for (i = 0; i < n; i++) {
      var sum = 0, cnt = 0, s = Math.floor(i * size), e = Math.max(s + 1, Math.floor((i + 1) * size));
      for (j = s; j < e && j < vals.length; j++) { sum += vals[j] * vals[j]; cnt++; }
      out.push(Math.sqrt(sum / Math.max(1, cnt)));
    }
    var sm = out.map(function (v, k) { var a = out[k - 1] || v, b = out[k + 1] || v; return (a + 2 * v + b) / 4; });
    var max = Math.max.apply(null, sm) || 1;
    return sm.map(function (v) { return Math.max(0.12, v / max); });
  }

  function bindGallery(root) {
    root.querySelectorAll('[data-dg-gallery]').forEach(function (g) {
      if (g.dataset.dgBound) return;
      g.dataset.dgBound = '1';
      var slides = g.querySelectorAll('[data-dg-slide]');
      var thumbs = g.querySelectorAll('[data-dg-thumb]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-dg-thumb');
          slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-dg-slide') === i); });
          thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* opts.url can be changed later: the next play() loads the new sound */
  function makePlayable(opts) {
    var self = { playing: false };
    function tick() {
      if (shared.owner !== self) return;
      var a = shared.audio;
      var pct = a && a.duration ? a.currentTime / a.duration : 0;
      opts.onProgress(pct, a ? a.currentTime : 0);
      if (self.playing) requestAnimationFrame(tick);
    }
    self.onStop = function () { self.playing = false; opts.onState(false); opts.onProgress(0, 0); };
    self.play = function (startPct) {
      var a = getAudio(self);
      if (a.dataset.src !== opts.url) { a.src = opts.url; a.dataset.src = opts.url; }
      a.onended = function () { self.playing = false; opts.onState(false); opts.onProgress(0, 0); };
      a.play().then(function () {
        if (startPct && a.duration) a.currentTime = startPct * a.duration;
        self.playing = true; opts.onState(true); requestAnimationFrame(tick);
      }).catch(function () {});
    };
    self.pause = function () { if (shared.owner === self && shared.audio) shared.audio.pause(); self.playing = false; opts.onState(false); };
    self.toggle = function () { if (self.playing && shared.owner === self) self.pause(); else self.play(); };
    self.seek = function (pct) {
      var a = shared.audio;
      if (shared.owner === self && a && a.duration && a.dataset.src === opts.url) {
        a.currentTime = pct * a.duration;
        opts.onProgress(pct, a.currentTime);
        if (!self.playing) self.play();
      } else self.play(pct);
    };
    return self;
  }

  /* hero demo: only when a real demo track exists */
  function initDemo(root) {
    if (root.dataset.dgBound) return;
    root.dataset.dgBound = '1';
    getTracks(root.getAttribute('data-product-id')).then(function (tracks) {
      var di = findDemo(tracks);
      if (di < 0) return;
      var t = tracks[di];
      var btn = root.querySelector('[data-dg-demo-play]');
      var bar = root.querySelector('[data-dg-demo-bar]');
      var time = root.querySelector('[data-dg-demo-time]');
      var total = seconds(t.duration);
      time.textContent = fmt(total);
      btn.innerHTML = ICON_PLAY;
      var p = makePlayable({
        url: t.url,
        onState: function (on) { btn.innerHTML = on ? ICON_PAUSE : ICON_PLAY; btn.setAttribute('aria-label', on ? 'Pause demo' : 'Play demo'); },
        onProgress: function (pct, cur) { bar.style.width = (pct * 100) + '%'; time.textContent = cur ? fmt(cur) + ' / ' + fmt(total) : fmt(total); }
      });
      btn.addEventListener('click', function () { p.toggle(); });
      root.hidden = false;
    });
  }

  /* sound previews: one main player + list */
  function initPreviews(root) {
    if (root.dataset.dgBound) return;
    root.dataset.dgBound = '1';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 0;
    var cover = root.getAttribute('data-cover') || '';
    var demoLabel = root.getAttribute('data-featured-label') || 'Demo';
    var soundLabel = root.getAttribute('data-sound-label') || 'Sound preview';
    getTracks(root.getAttribute('data-product-id')).then(function (tracks) {
      if (!tracks.length) return;
      root.hidden = false;
      var di = findDemo(tracks);
      if (di < 0) di = findLongest(tracks);
      var featured = root.querySelector('[data-dg-featured]');
      var tilesEl = root.querySelector('[data-dg-tiles]');
      var order = [di].concat(tracks.map(function (_, i) { return i; }).filter(function (i) { return i !== di; }));

      featured.innerHTML = '<div class="dg-ftrack">'
        + '<div class="dg-ftrack__art">' + (cover ? '<img alt="" loading="lazy">' : '') + '<button type="button" class="dg-ftrack__play" aria-label="Play">' + ICON_PLAY + '</button></div>'
        + '<div class="dg-ftrack__main"><span class="dg-ftrack__label"></span><span class="dg-ftrack__title"></span><div class="dg-ftrack__wave" aria-hidden="true"></div>'
        + '<div class="dg-ftrack__meta">' + EQ + '<span class="dg-ftrack__time"></span></div></div></div>';
      var box = featured.firstChild;
      if (cover) box.querySelector('.dg-ftrack__art img').src = cover;
      var labelEl = box.querySelector('.dg-ftrack__label');
      var titleEl = box.querySelector('.dg-ftrack__title');
      var timeEl = box.querySelector('.dg-ftrack__time');
      var wave = box.querySelector('.dg-ftrack__wave');
      var fbtn = box.querySelector('.dg-ftrack__play');
      var waveW = wave.clientWidth || (window.innerWidth < 750 ? 200 : 560);
      var N = Math.max(28, Math.min(110, Math.floor(waveW / 5)));
      var spans = [];
      var head = null;
      var cur = -1;
      var total = 0;
      var lastUpto = -1;
      var hot = [];
      var tiles = {};

      function clearHot() { hot.forEach(function (s) { s.classList.remove('is-hot'); }); hot = []; }
      function buildWave(i, animate) {
        wave.innerHTML = '';
        spans = [];
        lastUpto = -1;
        hot = [];
        var vals = smoothBars(tracks[i].waveform, N);
        vals.forEach(function (v, k) {
          var s = document.createElement('span');
          if (animate && !reducedMotion) {
            s.style.height = '6%';
            s.style.transitionDelay = Math.round(k * (420 / N)) + 'ms';
          } else {
            s.style.height = Math.round(v * 100) + '%';
          }
          s.dataset.h = Math.round(v * 100);
          wave.appendChild(s);
          spans.push(s);
        });
        head = document.createElement('i');
        head.className = 'dg-ftrack__head';
        wave.appendChild(head);
        if (animate && !reducedMotion) {
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            spans.forEach(function (s) { s.style.height = s.dataset.h + '%'; });
            setTimeout(function () { spans.forEach(function (s) { s.style.transitionDelay = ''; }); }, 900);
          }); });
        }
      }
      function paint(pct) {
        var upto = pct > 0 ? Math.min(spans.length - 1, Math.floor(pct * spans.length)) : -1;
        if (upto !== lastUpto) {
          var from = Math.min(upto, lastUpto) + 1, to = Math.max(upto, lastUpto);
          for (var k = Math.max(0, from); k <= to && k < spans.length; k++) spans[k].classList.toggle('is-played', k <= upto);
          lastUpto = upto;
          clearHot();
          if (upto >= 0 && !reducedMotion && fp.playing) {
            for (var h = upto - 1; h <= upto + 1; h++) { if (spans[h]) { spans[h].classList.add('is-hot'); hot.push(spans[h]); } }
          }
        }
        if (head) { head.style.left = (pct * 100) + '%'; head.style.opacity = pct > 0 ? '1' : '0'; }
      }
      var opts = {
        url: '',
        onState: function (on) {
          fbtn.innerHTML = on ? ICON_PAUSE : ICON_PLAY;
          fbtn.setAttribute('aria-label', on ? 'Pause' : 'Play');
          box.classList.toggle('is-active', on);
          if (!on) clearHot();
          var t = tiles[cur];
          if (t) { t.el.classList.toggle('is-active', on); t.icon.innerHTML = on ? ICON_PAUSE : ICON_PLAY; }
        },
        onProgress: function (pct, c) {
          paint(pct);
          timeEl.textContent = c ? fmt(c) + ' / ' + fmt(total) : fmt(total);
          var t = tiles[cur];
          if (t) t.bar.style.width = (pct * 100) + '%';
        }
      };
      var fp = makePlayable(opts);

      function select(i, autoplay) {
        if (i === cur) { if (autoplay) fp.toggle(); return; }
        if (fp.playing) fp.pause();
        var old = tiles[cur];
        if (old) { old.el.classList.remove('is-current', 'is-active'); old.icon.innerHTML = ICON_PLAY; old.bar.style.width = '0%'; }
        cur = i;
        var t = tracks[i];
        opts.url = t.url;
        total = seconds(t.duration);
        labelEl.textContent = isDemo(t) ? demoLabel : soundLabel;
        titleEl.textContent = t.title || '';
        timeEl.textContent = fmt(total);
        buildWave(i, autoplay);
        if (autoplay && !reducedMotion) {
          box.classList.remove('is-switch');
          void box.offsetWidth;
          box.classList.add('is-switch');
        }
        var nt = tiles[i];
        if (nt) nt.el.classList.add('is-current');
        if (autoplay) fp.play();
      }

      fbtn.addEventListener('click', function () { fp.toggle(); });
      wave.addEventListener('click', function (e) {
        var r = wave.getBoundingClientRect();
        fp.seek(Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)));
      });

      var shown = 0;
      order.forEach(function (ti) {
        var t = tracks[ti];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dg-tile';
        b.innerHTML = '<span class="dg-tile__icon">' + ICON_PLAY + '</span><span class="dg-tile__name"></span>' + EQ + '<span class="dg-tile__time"></span><span class="dg-tile__bar"></span>';
        var name = t.title || '';
        b.querySelector('.dg-tile__name').textContent = name;
        b.querySelector('.dg-tile__time').textContent = fmt(seconds(t.duration));
        b.setAttribute('aria-label', 'Play ' + name);
        tiles[ti] = { el: b, icon: b.querySelector('.dg-tile__icon'), bar: b.querySelector('.dg-tile__bar') };
        b.addEventListener('click', function () { select(ti, true); });
        if (limit && shown >= limit) b.hidden = true;
        shown++;
        tilesEl.appendChild(b);
      });

      select(di, false);

      var count = order.length;
      if (limit && count > limit) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'dg-btn dg-btn--secondary dg-previews__more';
        more.textContent = (root.getAttribute('data-more-label') || 'Show all [count] sounds').replace('[count]', count);
        more.addEventListener('click', function () { Object.keys(tiles).forEach(function (k) { tiles[k].el.hidden = false; }); more.remove(); });
        root.appendChild(more);
      }
      initReveal(root);
    });
  }

  function bindUpsell() {
    var slot = document.querySelector('[data-dg-upsell-slot]');
    if (!slot || slot.dataset.dgBound) return;
    slot.dataset.dgBound = '1';
    var form = document.querySelector('#MainContent > .shopify-section[id$="__main"] form[action*="/cart/add"]');
    if (!form) return;
    function isOffer(el) {
      if (!el || el.nodeType !== 1) return false;
      if (/\b(add-to-cart|product-form-buttons|shopify-payment-button|accelerated)/i.test(el.className || '')) return false;
      if (el.matches('input, button, product-form-buttons, shopify-accelerated-checkout, shopify-buy-it-now-button')) return false;
      return /(Claim Offer|Bundle Discount|Frequently bought|Add selected|Upsell)/i.test(el.textContent || '') || /essential|upsell/i.test((el.className || '') + ' ' + (el.id || ''));
    }
    function sweep() {
      Array.prototype.slice.call(form.children).forEach(function (el) { if (isOffer(el)) slot.appendChild(el); });
    }
    sweep();
    var mo = new MutationObserver(sweep);
    mo.observe(form, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function setup(root) {
    root = root || document;
    bindGallery(root);
    root.querySelectorAll('[data-dg-demo]').forEach(initDemo);
    root.querySelectorAll('[data-dg-previews]').forEach(initPreviews);
    bindUpsell();
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(document); });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
